import { useContext } from 'react'
import { useRequiredContext } from '../../../legacy/contexts/utils'
import { PartnerContext } from './PartnerContext'

export const usePartnerContext = () => useRequiredContext(PartnerContext)
export const useOptionalPartnerContext = () => useContext(PartnerContext)
